module.exports = __webpack_public_path__ + "assets/3.115379d1.svg";